module.exports = __webpack_public_path__ + "static/images/details-5.139533b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/product/ssk/details-5.png
// module id = tl6v
// module chunks = 0